export const CHART_MARGIN = 20;
